import { useMutation } from '@occc-app/dataAccessLayer/utils';
import { useScanDataGenerateSubmissionCsvMutation } from '@occc/graphql';

export const useScanDataGenerateSubmissionCSV = () =>
  useMutation(useScanDataGenerateSubmissionCsvMutation);
